import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "574ace38-1255-405a-a20d-07a607e54994",
  publicId: "24",
  name: "Common experimental methods [Common listening test procedures]",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, task01, task02],
};

export default lesson;
